import RadarGraphContainer from './container/RadarGraphContainer'

export default RadarGraphContainer